export interface SceneAct {
  id: 'semente' | 'flor' | 'buque' | 'jardim' | 'entrega' | 'atelie'
  label: string
  start: number
  end: number
}

export type SceneActId = SceneAct['id']

const semente: SceneAct = {
  id: 'semente',
  label: 'Semente',
  start: 0,
  end: 0.125,
}
const flor: SceneAct = { id: 'flor', label: 'A Flor', start: 0.125, end: 0.25 }
const buque: SceneAct = { id: 'buque', label: 'O Buquê', start: 0.25, end: 0.5 }
const jardim: SceneAct = {
  id: 'jardim',
  label: 'O Jardim',
  start: 0.5,
  end: 0.75,
}
const entrega: SceneAct = {
  id: 'entrega',
  label: 'A Entrega',
  start: 0.75,
  end: 0.875,
}
const atelie: SceneAct = {
  id: 'atelie',
  label: 'O Ateliê',
  start: 0.875,
  end: 1,
}

export const ACTS: SceneAct[] = [semente, flor, buque, jardim, entrega, atelie]

export function resolveActForProgress(progress: number): SceneAct {
  const clamped = Math.min(1, Math.max(0, progress))
  return ACTS.find((act) => clamped >= act.start && clamped < act.end) ?? atelie
}

export function resolveActById(id: SceneActId): SceneAct {
  return ACTS.find((act) => act.id === id) ?? semente
}
